module.exports = __webpack_public_path__ + "static/media/Clicking-sound-effect.a1cfcb1e.mp3";